module.exports = __webpack_public_path__ + "img/bg-map.af7b8af7.png";